module.exports = __webpack_public_path__ + "static/media/ProblemSolving.f7756500.mp3";